module.exports = __webpack_public_path__ + "img/16m004-03.fdbb1c69.jpg";